(angular => {
  "use strict";

  angular.module("Pages").controller("Pages.certificateCtrl", [
    "$q",
    "moment",
    "Loader",
    "Toast",
    "AuthService",
    "ParticipantService",
    "EventQuestionService",
    QuestionsCtrl
  ]);

  function QuestionsCtrl($q, moment, loader, Toast, authService, participantService, eventQuestionService) {
    this.hasAnswered = false;
    this.user = authService.getTokenData();
    this.message = 'loading';
    this.options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    loader.add($q.all([
      participantService.current(),
      eventQuestionService.hasAnswered()
    ])).then(([participant, hasAnswered]) => {
      this.message = null;
      this.event = participant.event;
      this.banner = this.event.assets.filter(a => a.type === "banner").map(a => a.path)[0];
      this.start_date = participant.event.start_date;
      const endDate = moment(this.event.end_date);
      const now = moment();
      const eventOver = now.isSameOrAfter(endDate, 'day');

      this.eventCertificate = this.event.assets.some(a => a.type === "certificate");

      if (this.user.preview) {
        return loader.add(eventQuestionService.list());
      }

      if (hasAnswered) {
        this.message = 'has-answered';
        return;
      }

      if (!eventOver && !this.event.publish_question && !this.eventCertificate) {
        this.message = 'question-not-allowed';
        return;
      }

      if (!this.event.publish_question && !this.eventCertificate) {
        this.message = 'question-not-allowed';
        return;
      }

      if (!this.eventCertificate && !this.event.publish_question) {
        this.message = 'not-certificate';
        return;
      }

      const allowedStatus = ['present', 'present at time'];
      if (!allowedStatus.includes(participant.status) && eventOver) {
        this.message = 'not-present';
        return;
      }

      const notAllowedStatus = ['invited', 'accepted', 'not invited'];
      if (notAllowedStatus.includes(participant.status) && !eventOver) {
        this.message = 'invited';
        return;
      }

      return loader.add(eventQuestionService.list());
    }).then(sections => {
      if (sections && !sections.length) {
        this.message = 'has-answered';
        return;
      }

      this.sections = sections;
    });

    this.certificate = () => {
      eventQuestionService.certificate();
    };

    this.save = () => {
      if (!this.event.publish_question) return;

      const answers = this.sections.reduce((acc, section) => {
        section.questions.filter(q => q.answer).forEach(q => acc.push({ question_id: q.id, answer: q.answer }));
        return acc;
      }, []);

      return loader.add(eventQuestionService.save(answers)).then(() => {
        Toast.show("Questionário salvo com sucesso", "success");
        this.message = 'has-answered';
      }).catch(() => {
        Toast.show("Questionário com erros", "error");
      });
    };


  }
})(angular);
